<!--
  功能：功能描述
  作者：lost
  邮箱：lost@daoyoudao.com
  时间：2021年06月02日 15:29:15
  版本：v1.0
-->
<template>
  <div class="agentManage">
    <div class="top">
      <div class="page-title">代理商管理</div>
      <div class="btn clearfix" v-if="savePermission">
        <el-button size="medium" type="primary" icon="" @click="showDialog = true">
          <i class="iconfont icon-tianjia-copy "></i>
          新增
        </el-button>
      </div>
    </div>
    <div class="tableBox">
      <el-table class="roleTable" :data="agentList" border v-loading="agentListLoading">
        <el-table-column prop="id" label="代理商ID" min-width="70"></el-table-column>
        <el-table-column prop="name" label="代理商名称" min-width="140"></el-table-column>
        <el-table-column prop="agencyCompany" label="代理商公司" min-width="140"></el-table-column>
        <el-table-column label="代理商状态" min-width="90">
          <template slot-scope="scope">
            <el-switch @change="switchChange(scope.row)" :value="scope.row.status === 1" :disabled="!checkPermission('enterprise:agency:update:status')"></el-switch>
          </template>
        </el-table-column>
        <el-table-column label="媒体类型">
          <template slot-scope="scope">{{ scope.row.mediaType | convertAgentType }}</template>
        </el-table-column>
        <el-table-column label="返点比例(%)" min-width="90">
          <template slot-scope="scope">{{ scope.row.rebatesProportion | toDecimal2 }}</template>
        </el-table-column>
        <el-table-column prop="createName" label="创建人" min-width="100"></el-table-column>
        <el-table-column label="创建时间" min-width="140">
          <template slot-scope="scope">{{ scope.row.createTime | getLocalTime3 }}</template>
        </el-table-column>
        <el-table-column label="操作" width="126" v-if="delPermission || updatesavePermission">
          <template slot-scope="scope">
            <div class="operating">
              <span @click="editAgent(scope.row)" v-if="updatesavePermission">编辑</span>
              <span @click="deleteAgent(scope.row.id)" v-if="delPermission">删除</span>
            </div>
          </template>
        </el-table-column>
      </el-table>
      <div class="paging-box" v-if="pageTotal > 0">
        <!-- <span class="page-total">显示全部项目{{pageTotal}}个项目</span> -->
        <el-pagination
          background
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
          :current-page="currentPage"
          :page-sizes="[10, 20, 40, 80, 100]"
          :page-size="pagesize"
          layout="total, sizes, prev, pager, next"
          :total="pageTotal"
        ></el-pagination>
      </div>
    </div>
    <add-agent ref="addAgentRef" v-if="showDialog" :show-dialog.sync="showDialog" @updateAgentList="updateAgentList()"></add-agent>
  </div>
</template>

<script>
import AddAgent from './components/add-agent'
export default {
  // 组件名称
  name: 'agentManage',
  // 组件参数 接收来自父组件的数据
  props: {},
  // 局部注册的组件
  components: { AddAgent },
  // 组件状态值
  data() {
    return {
      showDialog: false,
      agentListLoading: false,
      agentList: [],
      // 分页相关
      currentPage: 1, // 初始当前显示页
      pagesize: 10, // 初始每页的数据条数
      pageTotal: 0, // 数据总条数
      // 权限指令属性, 避免多次初始化
      savePermission: false,
      updatesavePermission: false,
      delPermission: false
    }
  },
  // 计算属性
  computed: {},
  // 侦听器
  watch: {},
  // 组件方法
  methods: {
    editAgent(row) {
      this.showDialog = true
      this.$nextTick(() => {
        this.$refs.addAgentRef.showEditAgent(row)
      })
    },
    deleteAgent(id) {
      console.log(id, '  id')
      this.$confirm('确认要删除吗？', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        this.$service
          .post('/api/enterprise/agency/delete', {
            id: id
          })
          .then(res => {
            console.log(res)
            this.$message({
              type: 'success',
              message: '删除成功!'
            })
            // 刷新列表
            this.getAgentList()
          })
          .catch(Err => {
            console.log(Err)
          })
      })
    },
    async switchChange(row) {
      row.status === 1 ? (row.status = 0) : (row.status = 1)
      try {
        const { code } = await this.$service.post('/api/enterprise/agency/update/status', {
          id: row.id,
          status: row.status
        })
        if (code === 200) {
          this.$message.success('修改成功!')
        }
      } catch (error) {
        console.log(error)
        row.status === 1 ? (row.status = 0) : (row.status = 1)
        // this.$message.warning('修改失败!')
      }
    },
    // 切换数据显示条数
    handleSizeChange(size) {
      this.pagesize = size
    },
    // 切换分页
    handleCurrentChange(currentPage) {
      this.currentPage = currentPage
    },
    updateAgentList() {
      this.getAgentList()
    },
    async getAgentList() {
      try {
        const { code, result } = await this.$service.post('/api/enterprise/agency/list', {
          pageNum: this.currentPage,
          pageSize: this.pagesize,
          platformType: parseInt(localStorage.platformType)
        })
        if (code === 200) {
          this.pageTotal = result.total
          this.agentList = result.pageData
        }
      } catch (error) {
        console.log(error)
      }
    }
  },

  // 组件在内存中被创建
  created() {
    // enterprise:agency:save
    this.updatesavePermission = this.checkPermission('enterprise:agency:update:save')
    this.savePermission = this.checkPermission('enterprise:agency:save')
    this.delPermission = this.checkPermission('enterprise:agency:delete')
    this.getAgentList()
  },
  /**
   * 组件被渲染到页面
   */
  mounted() {}
}
</script>

<style lang="less">
@import './../../../styles/accountManage/agentManage.less';
</style>



// WEBPACK FOOTER //
// src/views/accountManage/agentmanage/index.vue